<mat-spinner class="app-spinner" [color]="color" [strokeWidth]="strokeWidth" [diameter]="diameter"></mat-spinner>
